<template>
  <column size="is-12-mobile is-6-tablet is-4-desktop is-6-widescreen is-6-fullhd">
    <card>
      <div class="field">
        <field label="Choose Company for Lever Integration">
          <div class=" is-expanded is-fullwidth">
            <div class="select is-fullwidth">
              <select v-model="companyId">
                <option :value="null">Choose Company</option>
                <option v-for="company in companies" :key="company.id" :value="company.id">
                  {{ company.name }}
                </option>
              </select>
            </div>
          </div>
        </field>
      </div>
      <h5 class="m-b-16" v-if="formCompanyId && !connectLoading && !leverConnected">Connect your ATS account</h5>
      <h5 class="m-b-16" v-if="formCompanyId && !connectLoading && leverConnected">ATS account is Connected</h5>
      <div  class="providers" v-if="formCompanyId && !connectLoading">
        <div v-if="leverConnected" :class="isWalletPath">
          <div class="icon-button-container">
            <figure v-tooltip="{content:'Connected: Click to disconnect <br> your Lever ATS', placement:'top-start',}" @click="toggleModal('lever')" class="image is-58x58 is-cursor-pointer"  title="name">
              <img src="@/assets/lever-active.png" width="70" height="70" alt="name" />
            </figure>
            <h4  class="m-t-8"><strong>Lever</strong></h4>
          </div>
        </div>
        <div v-else :class="isWalletPath">
          <div class="icon-button-container" v-if="loading">
            <spinner size="medium"  class="spinner" />
          </div>
          <div class="icon-button-container" v-else>
            <figure @click="toggleGreenHouseModal('lever')" class="image is-58x58 is-cursor-pointer"  title="name">
              <img src="@/assets/lever.png" width="70" height="70" class="is-rounded" alt="name" />
            </figure>
            <h4  class="m-t-8"><strong>Lever</strong></h4>
          </div>
        </div>
        <div class="mt-20 " v-if="leverConnected && isHirer">
<!--          <div>-->
<!--            <text-field label="Webhook URL" placeholder="Lever WebHook URL" v-model="formWebhookUrl" readonly/>-->
<!--            <a :class="getCopyStyle"-->
<!--               v-clipboard:copy="formWebhookUrl"-->
<!--               v-clipboard:success="onCopy">-->
<!--              {{$t('referrals.copyToClipboard')}}-->
<!--              <small class="copy-lbl" v-if="copyToClipboardWebhook">{{this.$t('profile.copied')}}!</small>-->
<!--            </a>-->
<!--          </div>-->

        </div>
      </div>
      <div v-if="connectLoading" class="mt-20 is-flex is-flex-column flex-center content-center">
        <div><spinner size="large"></spinner></div>
        <h3 class="heading">Loading...</h3>
      </div>
    </card>
  </column>
</template>

<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import Spinner from 'vue-simple-spinner'
import ProviderWithIcon from '@/components/wallet/provider-with-icon'
import Field from '@/components/general/field'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import Card from '@/components/general/card'
import TextField from '../general/text-field'

export default {
  props: {
    isWallet: {
      type: Boolean,
      default: false
    },
    companies: {
      type: Array
    },
    toggleGreenHouseModal: {
      type: Function
    },
    toggleModal: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      modalActive: false,
      greenHouseModal: false,
      copyToClipboardWebhook: false,
      copyToClipboardUsername: false
    }
  },
  components: {
    TextField,
    Field,
    ProviderWithIcon,
    Spinner,
    Columns,
    Column,
    Card
  },
  computed: {
    ...mapState('users', ['user']),
    ...mapState('lever', {
      leverConnected: 'leverConnected',
      error: 'error',
      feedbackMessage: 'feedbackMessage',
      disconnectLoading: 'disconnectLoading',
      connectLoading: 'loading',
      formWebhookUrl: 'webhookUrl',
      formAuthUsername: 'authUsername',
      formAuthPassword: 'authRegPassword',
      gpLoading: 'gpLoading',
      authRegPassword: 'authRegPassword',
      formCompanyId: 'companyId'
    }),
    ...mapState('sigproviders', [
      'authenticated',
      'message',
      'wallet',
      'activeProvider',
      'connecting'
    ]),
    ...mapState('wallet', [
      'linkedAccount', 'isStackConnected', 'stackUserData'
    ]),
    ...mapGetters('sigproviders', [
      'providers',
      'account'
    ]),
    webhookUrl: {
      get () { return this.formWebhookUrl },
      set (value) { }
    },
    authUsername: {
      get () { return this.formAuthUsername },
      set (value) { }
    },
    authPassword: {
      get () { return this.formAuthPassword },
      set (value) { }
    },
    companyId: {
      get () { return this.formCompanyId },
      set (value) { this.setCompanyId(value); this.setWebhookUrl(''); if (value) { this.resetGreenhouseForm(); this.getLeverUsers(); this.checkLeverStatus() } }
    },
    getCopyStyle () {
      return this.copyToClipboardWebhook ? 'copyClipboard copyClipboardClicked' : 'copyClipboard'
    },
    getCopyStyleUsername () {
      return this.copyToClipboardUsername ? 'copyClipboard copyClipboardClicked' : 'copyClipboard'
    },
    showBanner: {
      get () {
        return this.feedbackMessage || false
      },
      set () {
        this.setFeedbackMessage(null)
        this.setError(false)
      }
    },
    getConnectedLabel () {
      return this.isStackConnected ? this.$t('wallet.connectedToHiro') : this.$t('wallet.connectYourStacks')
    },
    getProvidersList () {
      const prods = ['Hiro Wallet']
      // this.providers.forEach(p => {
      //   prods.push(p.meta.name)
      // })
      return prods.join(', ')
    },
    isWalletPath () {
      return this.$router.history.current.path === '/wallet' ? '' : 'outer-container'
    },
    isHirer () {
      return !!(this.user && this.user.profile === 'hirer')
    }
  },
  methods: {
    ...mapActions('sigproviders', [
      'initProviders',
      'detectSignatureProvider'
    ]),
    ...mapActions('lever', ['getLeverUsers', 'generatePassword', 'checkLeverStatus']),
    ...mapActions('domain', ['fetchJobTypes']),
    ...mapMutations('lever', ['setWebhookUrl', 'setLeverAuth', 'setError', 'resetGreenhouseForm', 'setFeedbackMessage', 'setCompanyId', 'resetGreenhouseForm']),
    onCopy () {
      this.copyToClipboardWebhook = true
      setTimeout(() => {
        this.copyToClipboardWebhook = false
      }, 2000)
    },
    onCopyUsername () {
      this.copyToClipboardUsername = true
      setTimeout(() => {
        this.copyToClipboardUsername = false
      }, 2000)
    },
    generateNewPassword () {
      this.generatePassword(this.user.companyId)
    },
    toggleDisconnect () {
      this.disconnectModal = !this.disconnectModal
    },
    contactHandler () {
    },
    linkHandler (wallet) {
      switch (wallet) {
        case 'hiro':
          window.open('https://www.hiro.so/wallet', '_blank').focus()
          break
        default:
          break
      }
    },
    disconnect () {
      this.$store.dispatch('sigproviders/disconnectWallet')
    }

  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/defaults.scss';
.providers {
  .provider {
    display: inline-block;
  }
}
.button {
  &.is-primary {
    &.is-outlined {
      background-color: #fff;
      &:hover {
        color: $primary-hover;
      }
    }
  }
}

.outer-container{
  display: flex;flex-direction: row; justify-content: flex-start
}

.no-hover{
  color:#44c7f0 !important;
}
.mr-2{
  margin-right: 6px;
}
.icon-button-container{
  display: flex;flex-direction: column; align-items: center
}
.link-text{
  cursor: pointer;
}
.is-58x58{
  width: 58px !important;
}
.copyClipboard {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #44C7F0;
  position: relative;
  top: -15px;

  .copy-lbl {
    font-size: 7px;
    padding: 2px 3.5px;
    border-radius: 2.6px;
    letter-spacing: 1px;
    position: relative;
    top: -2px;
    left: 2px;
  }
}

.copyClipboardClicked{
  color: #44C7F0;
  font-weight: bold;
  .copy-lbl{
    font-size: 9px;
    font-weight: bold;
    padding: 2px 3.5px;
    border-radius: 2.6px;
    letter-spacing: 1px;
    position: relative;
    top: -2px;
    left: 2px;
  }
}
.mt-20{
  margin-top: 20px;
}
.mt-8{
  margin-top: 8px;
}
.green-house-inputs{
  width: 60%
}
@media (max-width: 1200px) {
  .green-house-inputs{
    width: 80%
  }
}
@media (max-width: 900px) {
  .green-house-inputs{
    width: 100%
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/lever-card.vue